// Language registry for the nav switcher.
//
// The authoritative list of *supported* codes lives in /js/shared/i18nInit.js
// (window.i18nConfig.supportedLanguages) because the lecture pages share it.
// This file only describes how they are labelled in the dropdown, in the order
// the pre-React nav listed them.

export const LANG_NAMES = {
  en: 'English', zh: 'Chinese (Simplified)', lzh: 'Classical Chinese', es: 'Spanish',
  de: 'German', fr: 'French', it: 'Italian', pt: 'Portuguese', ja: 'Japanese',
  ko: 'Korean', th: 'Thai', vi: 'Vietnamese', ru: 'Russian', hi: 'Hindi',
  ar: 'Arabic', he: 'Hebrew', fa: 'Persian', ur: 'Urdu',
};

export const LANGUAGES = [
  { code: 'en',  native: 'English' },
  { code: 'zh',  native: '中文',      english: 'Chinese' },
  { code: 'lzh', native: '文言文',    english: 'Classical Chinese' },
  { code: 'es',  native: 'Español',   english: 'Spanish' },
  { code: 'fr',  native: 'Français',  english: 'French' },
  { code: 'de',  native: 'Deutsch',   english: 'German' },
  { code: 'ja',  native: '日本語',    english: 'Japanese' },
  { code: 'ko',  native: '한국어',    english: 'Korean' },
  { code: 'pt',  native: 'Português', english: 'Portuguese' },
  { code: 'it',  native: 'Italiano',  english: 'Italian' },
  { code: 'ru',  native: 'Русский',   english: 'Russian' },
  { code: 'hi',  native: 'हिन्दी',      english: 'Hindi' },
  { code: 'th',  native: 'ไทย',       english: 'Thai' },
  { code: 'vi',  native: 'Tiếng Việt', english: 'Vietnamese' },
  { code: 'ar',  native: 'العربية',    english: 'Arabic' },
  { code: 'he',  native: 'עברית',     english: 'Hebrew' },
  { code: 'fa',  native: 'فارسی',     english: 'Persian' },
  { code: 'ur',  native: 'اردو',      english: 'Urdu' },
];

export const DISPLAY_MODES = [
  { id: 'auto',    label: 'Auto' },
  { id: 'replace', label: 'Hover replace' },
  { id: 'tooltip', label: 'Hover tooltip' },
];

export const LLM_MODEL = 'Anthropic Claude Sonnet';

export function nativeName(code) {
  const found = LANGUAGES.find((l) => l.code === code);
  return found ? found.native : code;
}

// Wording is identical to the pre-React disclaimer — it is user-facing copy that
// has already been through review, and the mode sentence changes with the mode.
export function disclaimerText(lang, mode) {
  const langName = LANG_NAMES[lang] || lang;
  const modeNote =
    mode === 'tooltip'
      ? 'Hover tooltip — hover over text to see the translation as a tooltip.'
      : mode === 'replace'
        ? 'Hover replace — hover over text to replace it with the translation.'
        : 'Auto — the entire page is translated automatically.';
  return (
    `The live translation to ${langName} is performed by Generative AI. ` +
    'There are times the translation may not be precise. ' +
    `${modeNote} Click any translated text to toggle back to English. ` +
    'Please refer to the original language (English) if you have questions.'
  );
}
